import { render, staticRenderFns } from "./CustomerEditPage.vue?vue&type=template&id=bff0225e&scoped=true"
import script from "./CustomerEditPage.vue?vue&type=script&lang=js"
export * from "./CustomerEditPage.vue?vue&type=script&lang=js"
import style0 from "./CustomerEditPage.vue?vue&type=style&index=0&id=bff0225e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff0225e",
  null
  
)

export default component.exports